module.exports = __webpack_public_path__ + "img/screen-effect.9023e6fc.png";